import { render, staticRenderFns } from "./PresetSettings.vue?vue&type=template&id=1ae8bf88&scoped=true&"
import script from "./PresetSettings.vue?vue&type=script&lang=ts&"
export * from "./PresetSettings.vue?vue&type=script&lang=ts&"
import style0 from "./PresetSettings.vue?vue&type=style&index=0&id=1ae8bf88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae8bf88",
  null
  
)

export default component.exports